import {figmaLayersEventBroker, FIGMA_LAYERS_EVENTS} from "@frontend/group/modules/fig-layers/event-broker";

/**
 *
 * @param {Array<File | FileFormURL> | File | FileFormURL} files
 * @param callback
 * @param _options
 */
export const initFigmaViewer = (files, callback, _options = {}) => {
  $('#figma-preview').modal();
  
  figmaLayersEventBroker.fire(FIGMA_LAYERS_EVENTS.INIT, {
    files,
    ..._options
  });
}
